<template>
    <div class="" v-if="vistorias != null">
        <div class="table-responsive" style="margin-left: 10px; margin-right: 10px;">
            <table class="table table-bordered">
                <thead class="table table-bordered">
                    <tr class="table">
                        <th scope="col">ID</th>
                        <th scope="col">Data Vistoria</th>
                        <th scope="col">Sincronizado em</th>
                        <th scope="col">Questionário</th>
                        <th scope="col">Placa</th>
                        <th scope="col" style="text-align: center;">Ações</th>    
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="v in vistorias" :key="v.id">
                        <td>{{v.id}}</td>
                        <td>{{formatDate(v.data)}}</td>
                        <td>{{formatDataSincro(v.data_sincronizacao)}}</td>
                        <td>{{v.questionario}}</td>
                        <td>{{v.placa}}</td>            
                        <td style="text-align: center;"> 
                            <a  class="icon-spacing btn">
                                <img title="Enviar comprovante de vistoria por e-mail" class="icon-spacing btn" src="../assets/img/email.png" @click="comprovanteVistoria(v.id)"/>
                            </a>
                            <a style="margin-top: 10px" target="_blank" :href="v.url_download">
                                <img  title="Visualizar PDF" class="icon-spacing btn" src="../assets/img/PDF.png"   />

                            </a>
                            <img src="../assets/img/clock.png" v-on:click="buscarHistorico(v.id)" title="Visualizar histórico da vistoria" style="margin-left: 13px" class="icon-spacing btn"/>
                            
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import APIv3 from '../services/apiv3-endpoints'
import moment from 'moment'


export default {
    props: {
        vistorias: Array,
        email: String,
        
    },

    data(){
        return {
            loading: false,
            emailDefinitivo: ""
        }
    },

    methods:{
        enviarPorEmail(formEmail,idVistoria){
            let email = formEmail 
        
            this.loading = true            
            APIv3.sendMail(idVistoria,email)
                .then(() => {
                    this.loading = false
                    this.showAlertSuccess()
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false
                    this.showAlertError()
                })
            
        },

        formatDate (date){
            return moment(date).format('DD/MM/YYYY')
        },

        formatDataSincro (date){
            return moment(date).format('DD/MM/YYYY HH:mm')
        },

        buscarHistorico(_idVistoria){
            this.$router.replace({ path: 'Historico', query: { idVistoria: _idVistoria }})
        },

        showAlertSuccess() {
            this.$swal("Sucesso","Email enviado com sucesso!", "success");
        },

        showAlertError() {
            this.$swal("Erro !","Houve um erro ao enviar email", "error");
        },

        async comprovanteVistoria(idVistoria){
            let emailVistoriador = this.email
            let form = await this.$swal({
                title: 'Comprovante de vistoria',
                text: 'Enviar comprovante de vistoria para:',
                input: 'text',
                inputPlaceholder: emailVistoriador,
                showCloseButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
            })
            if(form.value == ''){
                form.value = emailVistoriador
            }

            if(!form.isConfirmed){
                return
            }
            this.alertLoadingEmail()
            this.enviarPorEmail(form.value,idVistoria)
        },

        alertLoadingEmail(){
            this.$swal({
                title: 'Enviando email',
                html: '<div class="spinner-grow text-success" role="status"><span class="sr-only">Loading...</span></div>',
                allowOutsideClick: false,
                showConfirmButton: false
            })
        }
    }

}

</script>

<style>

    .icon-spacing{
        margin-left: 5px;
        padding: 5px;
    }



    th{
        font-size: 14pt;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: lighter;
    }

</style>